import { render, staticRenderFns } from "./SolidProfile.vue?vue&type=template&id=187d2f12&scoped=true&"
import script from "./SolidProfile.vue?vue&type=script&lang=js&"
export * from "./SolidProfile.vue?vue&type=script&lang=js&"
import style0 from "./SolidProfile.vue?vue&type=style&index=0&id=187d2f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d2f12",
  null
  
)

export default component.exports